import { render, staticRenderFns } from "./square.vue?vue&type=template&id=dd053d5e&scoped=true&"
import script from "./square.vue?vue&type=script&lang=js&"
export * from "./square.vue?vue&type=script&lang=js&"
import style0 from "./square.vue?vue&type=style&index=0&id=dd053d5e&scoped=true&lang=css&"
import style1 from "./square.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd053d5e",
  null
  
)

export default component.exports